import {ImageSize} from "./imageUtils";

export const IMAGE_SIZES = {
  THUMBNAIL: "thumbnail",
  SMALL: "small",
  QUICK_VIEW: "quick-view-menu-item",
  DAILY_MENU: "daily-menu",
  DISH_PAGE: "dish-page",
  BRAND_HERO: "brand-hero", // default
  BRAND_HERO_SMALL: "brand-hero-small",
  BRAND_HERO_MEDIUM: "brand-hero-medium",
};

export const IMAGE_SIZE_MAP = {
  [IMAGE_SIZES.THUMBNAIL]: new ImageSize(160, 160),
  [IMAGE_SIZES.SMALL]: new ImageSize(70, 50),
  [IMAGE_SIZES.QUICK_VIEW]: new ImageSize(600, 600),
  [IMAGE_SIZES.DAILY_MENU]: new ImageSize(580, 500),
  [IMAGE_SIZES.DISH_PAGE]: new ImageSize(640, 460),
  // Max hero size is 1000px, 1.5 for Retina
  [IMAGE_SIZES.BRAND_HERO]: new ImageSize(1500, 700),
  [IMAGE_SIZES.BRAND_HERO_MEDIUM]: new ImageSize(1024, 464),
  [IMAGE_SIZES.BRAND_HERO_SMALL]: new ImageSize(650, 460),
};

export function getResolutionImgUrl(url: string, size?: string): string {
  if (size && size in IMAGE_SIZE_MAP) {
    const imageSize = IMAGE_SIZE_MAP[size];
    return imageSize.getResizedUrl(url);
  }

  return url + "640x460/60/";
}
